const mutations = {
    userLogin(state, userData) {
        if (userData.head != undefined || userData.head === null) {
            userData.head = (userData.head == null || userData.head == '') ? userData.defaultImg : userData.head
        }
        if (userData.privilege != undefined || userData.privilege === null) {
            userData.privilege = (userData.privilege == null || userData.privilege == '') ? '' : userData.privilege
            userData.privilege = userData.privilege.replace(/&/g, ',')
            userData.privilege = userData.privilege.split(',')
        }
        if (userData.waf_condition != undefined || userData.waf_condition === null) {
            userData.waf_condition = dealDetail(userData.waf_condition_1, userData.waf_condition_2)
            for (let i in userData.waf_condition) {
                userData.waf_condition[i] = parseInt(userData.waf_condition[i])
            }
        }
        state.userInfo = Object.assign({}, state.userInfo, userData)
    },
    navList(state, navList) {
        state.navList = navList
    },
    webCC(state, data) {
        state.webCinfo = Object.assign({}, state.webCinfo, data)
    },
    myTotice(state, data) {
        state.userInfo.scanMeal = data
    }
}
let arrName1 =
{
    deny_method: "1",
    header_length: "2",
    suffix: "3",
    response_code: "4",
    response_content: "5",
    ip_black_list: "6",
    url_filter: "8"
},
    arrName2 =
    {
        ip_white_list: "3",
        url_white_list: "4",
        tamper_proof_url: "2",
        "1": {
            transform_id: "1",
            transform_name: "2",
            transform_tag: "3",
        }
    }
function dealDetail(waf1, waf2) {
    var obj = {}
    let obj1 = dealObj(waf1, arrName1)
    let obj2 = dealObj(waf2, arrName2)
    obj = Object.assign({}, obj1, obj2)
    return obj
}
function dealObj(waf2, arrName2) {
    var obj = {}
    for (let i in waf2) {
        if (typeof (waf2[i]) == 'object') {
            obj = Object.assign({}, obj, dealObj(waf2[i], arrName2[i]))
            continue
        }
        for (let j in arrName2) {
            if (i == arrName2[j]) {
                obj[j] = waf2[i]
            }
        }
    }
    return obj
}
export default mutations



// WEBPACK FOOTER //
// ./src/jvsit/vuex/mutations.js